export default __webpack_public_path__ + "static/ashton-2a2680ae72047ecf04c9744b78d976b9.jpg";